import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "@/lib/observability/sentry";

// No-op if VITE_SENTRY_DSN isn't set -- safe in dev / preview.
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
